import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core"
import useStyles from "./styles"
import { isEmpty } from "lodash"
import { toggleManageExpensesDialog } from "../../../../actions/billingDialogs"

const markupTypeChoices = [{ value: 0, label: "$" }, { value: 1, label: "%" }]
const expenseTypeChoices = [
  { value: "expense", label: "Expense" },
  { value: "income", label: "Income" },
  { value: "discount", label: "Discount" },
]

const ManageExpensesDialog = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  //State for Expense / Non-Expense selection
  const [dialogData, setDialogData] = useState({
    name: "",
    type: "expense",
    default_description: "",
    default_is_percentage: 0,
    default_client_value: 0,
    default_actual_rate: 0,
  })

  const cleanCreateData = {
    name: "",
    type: "expense",
    default_description: "",
    default_is_percentage: 0,
    default_client_value: 0,
    default_actual_rate: 0,
  }

  const open = useSelector(
    state => state.billingDialogs.manageExpensesDialogOpen
  )
  const data = useSelector(state => state.billingDialogs.data)

  //Dialog expects the following:
  const chosenExpense = (data && data.chosenExpense) || {}
  const funcArgs = (data && data.funcArgs) || []
  const expenseFunc = (data && data.expenseFunc) || null

  // settingdialog data if it's passed (e.g., edit)
  // otherwise initializes as empty object for creation
  useEffect(
    () => {
      if (!isEmpty(data) && !isEmpty(chosenExpense)) {
        setDialogData({
          ...data.chosenExpense,
        })
      } else {
        setDialogData(cleanCreateData)
      }
    },
    [open]
  )

  const handleChange = (value, inputName) => {
    setDialogData(oldState => ({
      ...oldState,
      [`${inputName}`]: value,
    }))
  }

  const submitDisabled =
    dialogData.name === "" || dialogData.default_description === ""

  const handleClose = () => {
    dispatch(toggleManageExpensesDialog(false))
    setDialogData(cleanCreateData)
  }

  // universal function to execute either edit or create
  const executeExpenseTypeFunc = () => {
    if (expenseFunc) {
      expenseFunc(...funcArgs, dialogData)
    }
    handleClose()
  }

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      PaperProps={{
        classes: {
          root: classes.dialogPaper,
        },
      }}
    >
      <DialogTitle disableTypography>
        <Typography variant="h2" align="left">
          {dialogData.id ? "Edit Expense" : "Add New Expense Type"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box mt={2} mb={2}>
          <TextField
            fullWidth
            InputProps={{ classes: { underline: classes.underline } }}
            value={dialogData.name || ""}
            placeholder="Name"
            onChange={e => handleChange(e.target.value, "name")}
          />
        </Box>
        <Box mt={2} mb={2}>
          <TextField
            fullWidth
            InputProps={{ classes: { underline: classes.underline } }}
            multiline
            value={dialogData.default_description}
            placeholder="Description"
            onChange={e => handleChange(e.target.value, "default_description")}
          />
        </Box>
        <Box
          mt={2}
          mb={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Select
            value={dialogData.default_is_percentage}
            onChange={e => {
              handleChange(Number(e.target.value), "default_is_percentage")
            }}
            className={classes.select}
            style={{ width: "45%" }}
          >
            {markupTypeChoices.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
                className={classes.menuItem}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <TextField
            fullWidth
            InputProps={{
              classes: { underline: classes.underline },
              inputProps: {
                min: "0",
                step: "0.01",
              },
            }}
            value={dialogData.default_client_value}
            placeholder="Default Markup"
            type="number"
            style={{ width: "45%" }}
            onChange={e => handleChange(e.target.value, "default_client_value")}
          />
        </Box>
        <Box
          mt={2}
          mb={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Select
            value={dialogData.type || "expenses"}
            onChange={e => handleChange(e.target.value, "type")}
            className={classes.select}
            style={{ width: "45%" }}
          >
            {expenseTypeChoices.map(option => (
              <MenuItem
                key={option.value}
                value={option.value}
                className={classes.menuItem}
              >
                {option.label}
              </MenuItem>
            ))}
          </Select>
          <TextField
            fullWidth
            InputProps={{
              classes: { underline: classes.underline },
              inputProps: {
                min: "0",
                step: "0.01",
              },
            }}
            value={dialogData.default_actual_rate}
            placeholder="Default Rate"
            type="number"
            style={{ width: "45%" }}
            onChange={e => handleChange(e.target.value, "default_actual_rate")}
          />
        </Box>
      </DialogContent>
      <DialogActions
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Button variant="outlined" color="primary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={executeExpenseTypeFunc}
          disabled={submitDisabled}
        >
          {dialogData.id ? "Edit" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ManageExpensesDialog
